import {
  clearUploadedOrganizationBrandingLogo,
  deleteOrganizationBrandingFailed,
  deleteOrganizationBrandingSuccess,
  fetchOrganizationBrandingFailed,
  fetchOrganizationBrandingSuccess,
  OrganizationBrandingActionTypes,
  previewOrganizationBrandingEmailFailed,
  previewOrganizationBrandingEmailRequested,
  previewOrganizationBrandingEmailSuccess,
  uploadOrganizationBrandingLogoFailed,
  uploadOrganizationBrandingLogoRequested,
  uploadOrganizationBrandingLogoSuccess,
  upsertOrganizationBrandingFailed,
  upsertOrganizationBrandingSuccess,
} from './organization-branding.actions';
import { OrganizationBrandingState } from './organization-branding.types';

export const initialState: OrganizationBrandingState = {
  profilesByOrganizationId: {},
  uploadedLogosByOrganizationId: {},
  emailPreviewsByOrganizationId: {},
  hasFetchedByOrganizationId: {},
  errorsByOrganizationId: {},
  uploadLogoErrorsByOrganizationId: {},
  emailPreviewErrorsByOrganizationId: {},
};

export default (
  state: OrganizationBrandingState = initialState,
  action: OrganizationBrandingActionTypes,
): OrganizationBrandingState => {
  switch (action.type) {
    case fetchOrganizationBrandingSuccess.type:
    case upsertOrganizationBrandingSuccess.type:
      return {
        ...state,
        profilesByOrganizationId: {
          ...state.profilesByOrganizationId,
          [action.payload.organizationId]: action.payload.profile,
        },
        uploadedLogosByOrganizationId: {
          ...state.uploadedLogosByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
        emailPreviewsByOrganizationId:
          action.type === fetchOrganizationBrandingSuccess.type
            ? {
                ...state.emailPreviewsByOrganizationId,
                [action.payload.organizationId]: undefined,
              }
            : state.emailPreviewsByOrganizationId,
        hasFetchedByOrganizationId: {
          ...state.hasFetchedByOrganizationId,
          [action.payload.organizationId]: true,
        },
        errorsByOrganizationId: {
          ...state.errorsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
        uploadLogoErrorsByOrganizationId: {
          ...state.uploadLogoErrorsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
        emailPreviewErrorsByOrganizationId: {
          ...state.emailPreviewErrorsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
      };

    case deleteOrganizationBrandingSuccess.type:
      return {
        ...state,
        profilesByOrganizationId: {
          ...state.profilesByOrganizationId,
          [action.payload.organizationId]: null,
        },
        uploadedLogosByOrganizationId: {
          ...state.uploadedLogosByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
        emailPreviewsByOrganizationId: {
          ...state.emailPreviewsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
        hasFetchedByOrganizationId: {
          ...state.hasFetchedByOrganizationId,
          [action.payload.organizationId]: true,
        },
        errorsByOrganizationId: {
          ...state.errorsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
        uploadLogoErrorsByOrganizationId: {
          ...state.uploadLogoErrorsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
        emailPreviewErrorsByOrganizationId: {
          ...state.emailPreviewErrorsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
      };

    case uploadOrganizationBrandingLogoRequested.type:
      return {
        ...state,
        uploadedLogosByOrganizationId: {
          ...state.uploadedLogosByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
        uploadLogoErrorsByOrganizationId: {
          ...state.uploadLogoErrorsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
      };

    case uploadOrganizationBrandingLogoSuccess.type:
      return {
        ...state,
        uploadedLogosByOrganizationId: {
          ...state.uploadedLogosByOrganizationId,
          [action.payload.organizationId]: action.payload.logo,
        },
        uploadLogoErrorsByOrganizationId: {
          ...state.uploadLogoErrorsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
      };

    case clearUploadedOrganizationBrandingLogo.type:
      return {
        ...state,
        uploadedLogosByOrganizationId: {
          ...state.uploadedLogosByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
        uploadLogoErrorsByOrganizationId: {
          ...state.uploadLogoErrorsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
      };

    case previewOrganizationBrandingEmailRequested.type:
      return {
        ...state,
        emailPreviewErrorsByOrganizationId: {
          ...state.emailPreviewErrorsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
      };

    case previewOrganizationBrandingEmailSuccess.type:
      return {
        ...state,
        emailPreviewsByOrganizationId: {
          ...state.emailPreviewsByOrganizationId,
          [action.payload.organizationId]: action.payload.preview,
        },
        emailPreviewErrorsByOrganizationId: {
          ...state.emailPreviewErrorsByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
      };

    case fetchOrganizationBrandingFailed.type:
      return {
        ...state,
        hasFetchedByOrganizationId: {
          ...state.hasFetchedByOrganizationId,
          [action.payload.organizationId]: true,
        },
        errorsByOrganizationId: {
          ...state.errorsByOrganizationId,
          [action.payload.organizationId]: action.payload.error,
        },
      };

    case uploadOrganizationBrandingLogoFailed.type:
      return {
        ...state,
        uploadedLogosByOrganizationId: {
          ...state.uploadedLogosByOrganizationId,
          [action.payload.organizationId]: undefined,
        },
        uploadLogoErrorsByOrganizationId: {
          ...state.uploadLogoErrorsByOrganizationId,
          [action.payload.organizationId]: action.payload.error,
        },
      };

    case previewOrganizationBrandingEmailFailed.type:
      return {
        ...state,
        emailPreviewErrorsByOrganizationId: {
          ...state.emailPreviewErrorsByOrganizationId,
          [action.payload.organizationId]: action.payload.error,
        },
      };

    case upsertOrganizationBrandingFailed.type:
    case deleteOrganizationBrandingFailed.type:
      return {
        ...state,
        errorsByOrganizationId: {
          ...state.errorsByOrganizationId,
          [action.payload.organizationId]: action.payload.error,
        },
      };

    default:
      return state;
  }
};
